var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcMoney(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_65_22888)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_65_22888",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.8147e-06H48V48H0V3.8147e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_65_22888)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.7188 35.3438C29.7188 36.8971 30.978 38.1562 32.5312 38.1562C34.0845 38.1562 35.3438 36.8971 35.3438 35.3438C35.3438 33.7905 34.0845 32.5312 32.5312 32.5312C30.978 32.5312 29.7188 31.2721 29.7188 29.7188C29.7188 28.1655 30.978 26.9062 32.5312 26.9062C34.0845 26.9062 35.3438 28.1467 35.3438 29.7",
    stroke: "#083342",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5312 22.6875V26.9062",
    stroke: "#083342",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5312 38.1563V42.3562",
    stroke: "#083342",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5938 32.5312C46.5938 40.2978 40.2978 46.5938 32.5312 46.5938C24.7647 46.5938 18.4688 40.2978 18.4688 32.5312C18.4688 24.7647 24.7647 18.4688 32.5312 18.4688C40.2978 18.4688 46.5938 24.7647 46.5938 32.5312Z",
    stroke: "#083342",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7187 8.4375C29.7187 12.3207 23.4228 15.4688 15.6562 15.4688C7.88972 15.4688 1.40625 12.3207 1.40625 8.4375C1.40625 4.55428 7.88972 1.40625 15.6562 1.40625C23.4228 1.40625 29.7187 4.55428 29.7187 8.4375Z",
    stroke: "#083342",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8579 23.3749C19.9872 23.8352 17.8821 24.0938 15.6563 24.0938C7.88976 24.0938 1.4063 20.9458 1.4063 17.0625",
    stroke: "#083342",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.40625 8.4375V33.9375C1.40625 37.8207 7.88972 40.9688 15.6562 40.9688C17.5158 40.9688 19.291 40.7883 20.9158 40.4604",
    stroke: "#083342",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7188 8.43741V18.75",
    stroke: "#083342",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4695 32.3905C17.5605 32.4828 16.6197 32.5312 15.6562 32.5312C7.8897 32.5312 1.40623 29.3832 1.40623 25.5",
    stroke: "#083342",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_65_22888"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMoney);
export default __webpack_public_path__ + "static/media/ic-money.033ce8466f5d361c08fd75181b1d031b.svg";
export { ForwardRef as ReactComponent };